// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"b8ecfd9f","257":"4ef83703","396":"db3dcf18","453":"d5bed59f","666":"3c481575","900":"466befd6"}[chunkId] + ".chunk.js";
};